"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.proposalCardContextOf = proposalCardContextOf;
var _react = _interopRequireDefault(require("react"));
var _CommentAnchorContext = require("./CommentAnchorContext");
var _OperationsLeftOutContext = require("./OperationsLeftOutContext");
var _ParagraphInsertionContext = require("./ParagraphInsertionContext");
var _ReplyTargetContext = require("./ReplyTargetContext");
var _TableChangeSentences = require("./TableChangeSentences");
var _TableOfContentsRedirectContext = require("./TableOfContentsRedirectContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function proposalCardContextOf(content, cardId) {
  var _content$operationsLe;
  if (content.kind === "comment") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentAnchorContext.CommentAnchorContext, {
      bookmarks: content.bookmarks,
      anchorText: content.anchorText,
      placement: content.placement,
      paragraphText: content.paragraphText
    });
  }
  if (content.kind === "paragraph") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ParagraphInsertionContext.ParagraphInsertionContext, {
      cardId: cardId,
      precedingParagraphBookmark: content.precedingParagraphBookmark,
      precedingParagraphText: content.precedingParagraphText
    });
  }
  if (content.kind === "reply") return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReplyTargetContext.ReplyTargetContext, {
    targetCommentId: content.targetCommentId,
    targetCommentText: content.targetCommentText
  });
  var editContext = editCardContextOf(content);
  var operationsLeftOut = (_content$operationsLe = content.operationsLeftOut) !== null && _content$operationsLe !== void 0 ? _content$operationsLe : [];
  if (operationsLeftOut.length === 0) return editContext;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1",
    "data-sentry-component": "proposalCardContextOf",
    "data-sentry-source-file": "ProposalCardContext.tsx",
    children: [editContext, /*#__PURE__*/(0, _jsxRuntime.jsx)(_OperationsLeftOutContext.OperationsLeftOutContext, {
      operationsLeftOut: operationsLeftOut,
      "data-sentry-element": "OperationsLeftOutContext",
      "data-sentry-source-file": "ProposalCardContext.tsx"
    })]
  });
}
function editCardContextOf(content) {
  if (content.kind === "table" && content.textRedline !== null && hasTableChanges(content.textRedline.tableChanges)) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableChangeSentences.TableChangeSentences, {
      textRedline: content.textRedline
    });
  }
  if (content.tableOfContentsRedirects.length > 0) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TableOfContentsRedirectContext.TableOfContentsRedirectContext, {
    redirects: content.tableOfContentsRedirects
  });
  return null;
}
function hasTableChanges(tableChanges) {
  return tableChanges.rowInsertions.length + tableChanges.rowDeletions.length + tableChanges.tableInsertions.length > 0;
}